import React, {useEffect} from 'react';
import {motion, AnimatePresence} from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import {characterDetails} from '../data/characterDetails';
import '../characterModal.css';

const {FiX} = FiIcons;

const stats = [
  ['Age', 'age'],
  ['Origin', 'origin'],
  ['Power', 'power']
];

export default function CharacterModal({character, onClose}) {
  useEffect(() => {
    if (!character) return undefined;
    const onKey = (e) => e.key === 'Escape' && onClose();
    document.body.style.overflow = 'hidden';
    window.addEventListener('keydown', onKey);
    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('keydown', onKey);
    };
  }, [character, onClose]);

  const details = character ? characterDetails[character.name] || {} : {};

  return (
    <AnimatePresence>
      {character && (
        <motion.div
          className="cm-backdrop"
          initial={{opacity: 0}}
          animate={{opacity: 1}}
          exit={{opacity: 0}}
          onClick={onClose}
        >
          {Array.from({length: 14}).map((_, i) => (
            <span
              key={i}
              className="cm-spark"
              style={{
                left: `${(i * 37) % 100}%`,
                animationDelay: `${(i % 7) * 0.8}s`,
                animationDuration: `${6 + (i % 5)}s`
              }}
            />
          ))}
          <motion.div
            className="cm-card"
            role="dialog"
            aria-modal="true"
            aria-label={character.name}
            initial={{opacity: 0, y: 60, scale: 0.9, rotateX: 12}}
            animate={{opacity: 1, y: 0, scale: 1, rotateX: 0}}
            exit={{opacity: 0, y: 40, scale: 0.94}}
            transition={{type: 'spring', damping: 24, stiffness: 180}}
            onClick={(e) => e.stopPropagation()}
          >
            <button className="cm-close" onClick={onClose} aria-label="Close">
              <SafeIcon icon={FiX} />
            </button>
            <div className="cm-portrait">
              {character.image ? (
                <img src={character.image} alt={character.name} />
              ) : (
                <span className="cm-initial">{character.name.charAt(0)}</span>
              )}
            </div>
            <div className="cm-body">
              <p className="cm-symbol">{character.symbol}</p>
              <h3>{character.name}</h3>
              <p className="cm-role">{character.role}</p>
              {details.quote && <blockquote>“{details.quote}”</blockquote>}
              <p className="cm-story">{details.backstory || character.description}</p>
              <div className="cm-stats">
                {stats.map(([label, key]) => details[key] && (
                  <div key={key}>
                    <small>{label}</small>
                    <span>{details[key]}</span>
                  </div>
                ))}
              </div>
              <div className="cm-traits">
                {(details.traits || []).map((t) => <span key={t}>{t}</span>)}
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
